import React, { useMemo } from "react"
import { Accordion, AccordionItem, BackgroundColor, SectionContainer } from "@silversea-ssc/ui-components-react"
import { Trans } from "@lingui/macro"
import { SanityQueryResponse } from "../../app-core/_common/sanity/sanity-types"
import TextBox from "../TextBox/TextBox"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import styles from "./DynamicFAQSection.module.scss"

type DynamicFAQSectionProps = {
    content: SanityQueryResponse["dynamicFAQ"]
    backgroundColor: BackgroundColor
}

const DynamicFAQSection: React.FC<DynamicFAQSectionProps> = ({ content, backgroundColor }) => {
    const [state] = useECommerceMachine()
    const stepForContent = state.context.flowVersion.ui.faqsForStep(state.context.activeStep)

    const faqsForStep = useMemo(
        () => content.filter((faq) => stepForContent && faq.visibleInSteps.includes(stepForContent)),
        [content, stepForContent],
    )

    if (faqsForStep.length == 0) return null

    return (
        <SectionContainer
            backgroundColor={backgroundColor}
            className={styles.wrapper}
            spacingTop="regular"
            spacingBottom="regular"
            id="faq"
        >
            <div className={styles.heading}>
                <h4 className={styles.headingTitle}>
                    <Trans>Frequently Asked Questions</Trans>
                </h4>
                <div className={styles.headingContent}>
                    <Trans>
                        Here you'll find clear and concise answers to the most common questions about our services,
                        products, and policies.
                    </Trans>
                </div>
            </div>
            <Accordion trackingName="dyanmic-faq">
                {faqsForStep.map((faq) => (
                    <AccordionItem
                        key={faq._key}
                        id={faq._key}
                        title={faq.title}
                        backgroundColor={backgroundColor == "white" ? "neutral05" : "white"}
                        trackingName={`faq-${faq.titleEN}`}
                    >
                        <TextBox content={faq.content} fontSize="small" />
                    </AccordionItem>
                ))}
            </Accordion>
        </SectionContainer>
    )
}

export default DynamicFAQSection
